import {useMemo} from 'react'
import {get} from 'react-hook-form'

import {FieldNames, isFieldDirty, normalizeFieldName} from '../../fields'
import {useDeepCompareMemo} from '../useFormEffect'
import {useOrderProcessFormContext} from '../useOrderProcessFormContext'

export const useDirtyFields = (fieldNames: readonly FieldNames[]) => {
  const {watch, formState} = useOrderProcessFormContext()
  const fieldsToWatch = useMemo(
    () => fieldNames.map((f) => normalizeFieldName(f).field),
    [fieldNames]
  )
  const defaultValues = formState.defaultValues
  const fieldValues = watch(fieldsToWatch)

  return useDeepCompareMemo(() => {
    return fieldNames
      .map((fieldName, index) =>
        isFieldDirty(
          fieldName,
          fieldValues[index],
          get(defaultValues, normalizeFieldName(fieldName).field)
        )
          ? fieldName
          : undefined
      )
      .filter(Boolean) as FieldNames[]
  }, [defaultValues, fieldNames, fieldValues])
}
